export default __webpack_public_path__ + "static/photo-1-78db0211b22064258b3973feb49fd2d7.jpg";